import React from "react";
import { Carousel, Image, Container } from "react-bootstrap";
import { motion } from "framer-motion";
import { FaQuoteLeft } from "react-icons/fa";
import man from "../assets/male.png";
import women from "../assets/woman.png";
import profile from "../assets/profile.png";

// Testimonials data
const testimonials = [
  {
    quote:
      "I had an issue with rescheduling the class and they solved the issue without any fees.",
    desc: "TaleemulQuran is providing an extraordinary service to Muslim students especially overseas. They have such a talented and experienced team of Hafez/Tutors who are always on time and In case of absence /leave of instructor, you get a cover-up of the class. The admins always listen to my queries and answer them effectively. It really makes a difference even apart from the teacher. Keep it up Allah will reward you for this Noble service.",
    name: "Nazim Uddin",
    country: "Australia",
    img: man,
  },
  {
    quote:
      "The tutors are extremely patient and professional. My child improved rapidly in Quran recitation.",
    desc: "The one-to-one online sessions are very interactive. The lesson planning is excellent, and progress reports are really helpful. Highly recommend TaleemulQuran to students worldwide.",
    name: "Sara Ahmed",
    country: "London, UK",
    img: women,
  },
  {
    quote: "Their scheduling system is so convenient and easy to use.",
    desc: "I can now plan my Quran lessons around my busy schedule. The team is always responsive and supportive. Exceptional service!",
    name: "Mohamed Ali",
    country: "France",
    img: profile,
  },
];

const TestimonialCarousel = () => {
  return (
    <section style={sectionStyle}>
      <Container
        style={{ width: "80%", backgroundColor: "#0d3b660f", cardStyle }}
      >
        <Carousel
          indicators={true}
          controls={true}
          interval={5000}
          pause="hover"
        >
          {testimonials.map((t, idx) => (
            <Carousel.Item key={idx}>
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.8 }}
                style={{ position: "relative", padding: "60px 20px" }}
              >
                {/* Background quote icon */}
                <FaQuoteLeft
                  style={{
                    position: "absolute",
                    top: "-20px",
                    left: "-10px",
                    fontSize: "6rem",
                    color: "#009dff9d",
                    zIndex: 0,
                  }}
                />

                <div
                  style={{
                    zIndex: 1,
                    position: "relative",
                    textAlign: "center",
                  }}
                >
                  <h3 style={quoteStyle}>&ldquo;{t.quote}&rdquo;</h3>
                  <p style={descStyle}>{t.desc}</p>
                  <div className="d-flex flex-column align-items-center mt-4">
                    <Image
                      src={t.img}
                      roundedCircle
                      width={80}
                      height={80}
                      style={{ objectFit: "cover", marginBottom: "10px" }}
                    />
                    <h5 style={nameStyle}>{t.name}</h5>
                    <p style={countryStyle}>{t.country}</p>
                  </div>
                </div>
              </motion.div>
            </Carousel.Item>
          ))}
        </Carousel>
      </Container>
    </section>
  );
};

// Styles
const sectionStyle = {
  backgroundColor: "#f9f9f9",
  padding: "80px 0",
};

const quoteStyle = {
  fontSize: "1.8rem",
  fontWeight: "600",
  color: "#0d3b66",
  marginBottom: "1rem",
};

const descStyle = {
  fontSize: "1rem",
  color: "#333",
  lineHeight: "1.6",
  maxWidth: "700px",
  margin: "0 auto",
};

const nameStyle = {
  fontSize: "1rem",
  fontWeight: "600",
  marginBottom: "0",
};

const countryStyle = {
  fontSize: "0.85rem",
  color: "#555",
  marginBottom: "0",
};
const cardStyle = {
  border: "1px solid #e0e0e0",
  borderRadius: "18px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
};

export default TestimonialCarousel;
